import React from "react";
import styled from 'styled-components';
import Pagination from 'rc-pagination';
import "rc-pagination/assets/index.css";
import { ClaroCardSimple } from "@claropay/shared";
import { Link } from "react-router-dom";
import { formatToCurrency } from "../GenericForm/utils/formatToCurrency";
import { floatToInteger } from "../GenericForm/utils/floatToInteger";
import { validateUserAgent } from "../utils";

const Container = styled.div`
    width: 100%;
    margin-bottom: ${props => props.marginPagination ? `${props.marginPagination}` : `auto`};

`;

const ContainerPagination = styled.div`
    width: 100%;
    text-align: center;
`;

const TitleSears = styled.p`
    font-size: 26px;
    margin:    7% 0em 0% 4%;
    padding:   0em 0em 0em 0em;
    font-family:  "Amx-Regular";
    color: #1e1e1e;
    text-align:  left;
    font-weight:  regular;
    font-style: normal;
    width: 92%
`;

const SubtitleSears = styled.p`
    font-size: 14px;
    margin:  3% 10% 10% 4%;
    padding:  0em 0em 0em 0em;
    font-family: "Amx-Regular";
    color: #626262;
    text-align:  left;
    font-weight: regular;
    font-style:  normal;
    width: 92%
`;

const Card = styled.div`
    margin:    5% auto;
    padding:   3% 3% 4% 3%;
    width: ${props => props.width ? props.width : '88%'};
    text-align: center;
    box-shadow: 0px 0px 2px 1px #e8e7e5;
    background: #fff;
    border-radius: 6px;
`;

const Text = styled.p`
    font-size: ${props => props.fontSize ? props.fontSize : '12px'};
    font-family: ${props => props.fontFamily ? props.fontFamily : 'Amx-Regular'};
    font-weight: ${props => props.fontWeight ? props.fontWeight : 'normal'};
    margin-top: ${props => props.marginTop ? props.marginTop : '5px'};
    margin-bottom: ${props => props.marginBottom ? props.marginBottom : '5px'};
    color: ${props => props.color ? props.color : ''};
`;

const Item = styled.div`
    margin: ${props => props.margin ? props.margin : '0% 0% 15px 0%'};
    padding: 0% 0% 0% 0%;
    width:${props => props.width ? props.width : '100%'};
    text-align: ${props => props.textAlign ? props.textAlign : 'left'};;
    float: ${props => props.float ? props.float : 'initial'};
`;  

const Hr = styled.hr`
    border-top: 1px dashed #cdcdcd;
    margin: 10% 1%;
    width: 97%;
`;

const JumpItem = styled.div`
    background-color:#f6f6f6!important;
    border-radius: 5px!important;
    color:#626262!important;
    box-shadow: 1px 5px 5px 0px rgba(178,178,178,0.57);
    width: 99%;
    height: 99%;
    margin-top: -1px;
    padding: 0%
    border: 1px solid #dedede!important;
`

const Button = styled.div`
    border: 2px solid black;
    border-radius: 25px;
    font-size: ${props => props.fontSize != undefined ? props.fontSize : "12px"};
    background: black;
    color: white;
    text-align: center;
    margin: 10px  auto;
    padding: 10px;
    font-weight: ${props => props.weight != undefined ? props.weight : "normal"};
    width: ${props => props.width ? props.width : "90%"};
`;


const PlansSears = ({
    plansSears,
    titlePlansCardSears, 
    subtitlePlansCardSears,
    onChangePagination,
    upperLimit,
    lowerLimit,
    handleOnClickCardInfo,
    handleOnClickInput,
    planSelected,
    showTooltipAmountDetail,
    handleOnClickAmountDetail,
    marginBottomPagination,
    handleOnChangeInput,
    sdkVersion,
    paymentsConfig,
    isClaroPartner,
    amount,
    inputValues,
    searsCardNumber,
    firstRender,
    paymentCard,
    changeInputValue,
    handleOnblur,
    clickInput
}) => {
    const totalCount = plansSears.paymentPlans.length
    let planCardArray = [];
    let displayCard = "block"; 
    let imgTooltipAmountDetail = (showTooltipAmountDetail)?"flecha_arriba.png":"flecha_abajo.png";
    const {minimumToPay, newBalanceCutting, billedBalance} = plansSears.accountDetails
    plansSears.paymentPlans.map(function(plan, key) {

        if(key >= lowerLimit && key < upperLimit){
            displayCard = "block"
        }else{
            displayCard = "none"
        }
        //const inputValue = (inputValues[key])? inputValues[key]:plan.minimumPaymentAmount
        const inputValue = (inputValues[key])
        let  inputValueFormatted
        if(firstRender){
            inputValueFormatted = parseFloat(inputValue).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            });

        } else{
            inputValueFormatted = parseFloat(inputValue).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            });
        }
        planCardArray.push(
            <Card style={{display: displayCard}} onClick={(event) => handleOnClickCardInfo(event, plan)} key={key}>
                <Item width={"50%"} float={"left"} >
                    <Text fontSize={"14px"}>
                        {"Plan de pago " }
                    </Text>
                    <Text fontWeight={"bold"} fontSize={"15px"} >
                        {floatToInteger(plan.payPlanNumber)}
                    </Text>
                </Item>
                <Item width={"50%"} float={"right"}>
                    <Text fontSize={"14px"}>
                        {"Secuencia"}
                    </Text>
                    <Text fontWeight={"bold"} fontSize={"15px"} >
                        {floatToInteger(plan.sequence)}
                    </Text>
                </Item>
                <Item width={"100%"}>
                    <Text fontSize={"14px"}>
                        {"Descripción"}
                    </Text>
                    <Text fontWeight={"bold"} fontSize={"15px"} >
                        {plan.planName}
                    </Text>
                </Item>
                <Item width={"33%"} float={"left"} margin={"0% 0% 30px 0%"}>
                    <Text fontSize={"14px"}>
                        {"Saldo"}
                    </Text>
                    <Text fontSize={"14px"}>
                        {"Facturado"}
                    </Text>
                    <Text fontWeight={"bold"} fontSize={"15px"} >
                        {"$" + formatToCurrency(plan.newBalanceCutting)}
                    </Text>
                </Item>
                <Item width={"33%"} float={"left"}>
                    <Text fontSize={"14px"} marginBottom={"0px"}>
                        {"Saldo"}
                    </Text>
                    <Text fontSize={"14px"} >
                        {"Actual"}
                    </Text>
                    <Text fontWeight={"bold"} fontSize={"15px"} >
                        {"$" + formatToCurrency(plan.balanceCutting)}
                    </Text>
                </Item>
                <Item width={"33%"} float={"right"}>
                    <Text fontSize={"14px"}>
                        {"Mínimo a"}
                    </Text>
                    <Text fontSize={"14px"}>
                        {"Pagar"}
                    </Text>
                    <Text fontWeight={"bold"} fontSize={"15px"} >
                        {"$" + formatToCurrency(plan.minimumPaymentAmount)}
                    </Text>
                </Item>
                <Hr/>
                <Item width={"100%"} >
                    <div style={{width: "50%", float: "left"}}>
                        <Text fontSize={"19px"}  fontWeight={"bold"} style={{display:"inline"}}>
                            {"Monto a pagar"}
                        </Text>
                    </div>
                    <div style={{textAlign: "end"}}>   
                        <input 
                            type="text"
                            pattern="[0-9]*"
                            inputMode="decimal"
                            placeholder="$0.00"
                            value = {inputValueFormatted}
                            onChange={(event) => handleOnChangeInput(event, key, plan)}
                            onClick={(event) => handleOnClickInput(event)}
                            onBlur={(event) => handleOnblur(event, key)}
                            id = {`input-amount-${key}`}
                            style={{
                                display:"inline",
                                border: "1px solid #fde3b1",
                                padding: "10px",
                                borderRadius: "5px",
                                margin: "-11% 0px 0px 0px",
                                width: "30%",
                                textAlign: "right",
                                fontSize: "15px",
                                fontFamily: "Amx-Regular",
                                fontWeight: "bold"
                            }}
                        />
                    </div>
                </Item>
            </Card>
        );
    });
    return(
        <>
        <Container marginPagination={marginBottomPagination}>
            <TitleSears >
                {titlePlansCardSears}
            </TitleSears>
            <SubtitleSears >
                {subtitlePlansCardSears}
            </SubtitleSears>
            {
                planCardArray
            }
            <ContainerPagination >
                <Pagination 
                    className="ant-pagination"
                    total={totalCount}
                    pageSize={5}
                    onChange={onChangePagination}
                    prevIcon={
                            <img src={"/images/iconoFlechaDetalle.svg"} />

                        }
                    nextIcon = {
                        <img src={"/images/icono_flecha_detalleSears.svg"} />
                    }
                    jumpNextIcon = {
                        <JumpItem>
                            <img src={"/images/dots.svg"} style={{width: '22px', paddingTop: '3px'}} />
                        </JumpItem>
                    }
                    jumpPrevIcon = {
                        <JumpItem>
                            <img src={"/images/dots.svg"} style={{width: '22px', paddingTop: '3px'}} />
                        </JumpItem>}
                />
            </ContainerPagination>
        </Container>
        <ClaroCardSimple 
            backgroundColor='#fff' 
            borderRadius='20px 20px 0px 0px'
            margin='0px'
            height={"auto"}
            style={{
                position:'fixed', 
                bottom: validateUserAgent() === "android" || clickInput ? "0vh" : "10vh",
                left:'0',
                width:"100%",
            }}
            fadeIn={"fadeIn"}
            fadeInTime={"2s"}
            cubicBezier={"cubic-bezier(0.9, 0, 0.9, 1)"}
            addCloseEfect = {false}
        >
            <Item textAlign={"center"} margin={"0px"}>
                <Text fontSize={"20px"} fontWeight={"bold"} marginTop={"0px"} marginBottom={"0px"}>
                    Monto total a pagar
                </Text>
            </Item>
            <Item textAlign={"center"} margin={"0px"}>
                <Text fontSize={"20px"} fontWeight={"bold"} marginTop={"10px"} marginBottom={"10px"} color={"rgba(166, 206, 77, 1)"}>
                    $ {changeInputValue ? formatToCurrency(amount) : formatToCurrency(minimumToPay)}
                    <img
                        style={{ height: '15px', verticalAlign: "middle", marginLeft:"8px"}}
                        src={"/images/"+ imgTooltipAmountDetail}
                        onClick={handleOnClickAmountDetail}
                    />
                </Text>
            </Item>
            {
                (showTooltipAmountDetail)?
                    <>
                    <Item width={"33%"} float={"left"} textAlign={"center"}>
                        <Text fontSize={"12px"}>
                            {"Saldo Fac."}
                        </Text>
                        <Text fontWeight={"bold"} fontSize={"15px"} >
                            {"$"+ formatToCurrency(planSelected.newBalanceCutting || billedBalance)}
                        </Text>
                    </Item>
                    <Item width={"33%"} float={"left"} textAlign={"center"}>
                        <Text fontSize={"12px"}>
                            {"Saldo Actual"}
                        </Text>
                        <Text fontWeight={"bold"} fontSize={"15px"} >
                            {"$" + formatToCurrency(newBalanceCutting)}
                        </Text>
                    </Item>
                    <Item width={"33%"} float={"right"} textAlign={"center"}>
                        <Text fontSize={"12px"}>
                            {"Mínimo a Pagar"}
                        </Text>
                        <Text fontWeight={"bold"} fontSize={"15px"} >
                            {"$" + formatToCurrency(minimumToPay)}
                        </Text>
                    </Item>
                    </>
                :<></>
            }
            <div style={{float: "left", width: "100%"}}>
                <Link 
                    to={{
                        pathname: '/sears',
                        state: {
                            sdkVersion: sdkVersion,
                            paymentsConfig: paymentsConfig, 
                            isClaroPartner: isClaroPartner,
                            amountPlan:  parseFloat(changeInputValue ? amount : minimumToPay),
                            infoPlanSears: planSelected,
                            noInternet: plansSears.accountDetails.noInternet,
                            searsCardNumber: searsCardNumber,
                            paymentCard: paymentCard
                        }
                    }}
                >
                    <Button fontSize={"14px"} weight={"bold"} width={"40%"} backgroundColor="#000000" >
                        {"Pagar"}
                    </Button>
                </Link>
            </div>
        </ClaroCardSimple>
        </>
    )
}

export default PlansSears;